module.exports = __webpack_public_path__ + "files/buetti-news.ab896955e9246c0cf77dcd0e6e933387.pdf";